import { useCallback, useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

const useTicket = () => {
  const authCtx = useContext(AuthContext);
  const { getAuthHeaders } = authCtx;
  const { isLoading, error, sendRequest } = useHttp();

  // Validates a scanned ticket QR payload (or booking number) and optionally
  // checks the customer in. Returns { result, checkedIn, booking }.
  const scanTicket = useCallback(
    async ({ code, checkIn = false, force = false }) => {
      const responseData = await sendRequest({
        url: '/api/v1/ticket/scan',
        method: 'POST',
        headers: getAuthHeaders(),
        body: { code, checkIn, force },
      });
      return responseData;
    },
    [sendRequest, getAuthHeaders]
  );

  // Downloads the PDF ticket for a booking as a Blob
  const getTicketPDF = useCallback(
    async bookingId => {
      const responseData = await sendRequest({
        url: `/api/v1/ticket/booking/${bookingId}/pdf`,
        method: 'GET',
        headers: getAuthHeaders(),
        returnBlob: true,
      });
      return responseData;
    },
    [sendRequest, getAuthHeaders]
  );

  return { scanTicket, getTicketPDF, isLoading, error };
};

export default useTicket;
